
import { Component, Vue, Emit } from "vue-property-decorator";
import { systemSrv } from "./../services/system";
import store from "./../store";
import Header from "../components/common/Header.vue";
import Footer from "../components/common/Footer.vue";
import router from "@/router";
import { cacheSrv } from "./../services/cache";
import { notiSrv } from "./../services/noti";
import SideMenu from "@/components/common/SideMenu.vue";

@Component({
  components: {
    Footer,
    SideMenu
  }
})
export default class Welcome extends Vue {
  profile = systemSrv.profile;
  activate;
  constructor() {
    super();
  }
  created() {}

  get menuOpen() {
    return store.state.menu.open;
  }

  //@Emit('menuState')
  activateSideMenu(activate) {
    console.log("activate", activate);
    this.activate = activate;
    //this.$emit('menuStateChanged', true)
    notiSrv.activateSideMenu(activate);
  }
  // activateSideMenu(activate){
  //   console.log("activating",activate)
  //   //notiSrv.activateSideMenu(activate)
  // }
}
